import {GenericAPI} from "./generic-api-client";

export default GenericAPI("plan-details");
